import girl from "./images/girl.png"
import electronic from "./images/electronics.png"
import clear from "./images/clear.png"
import furniture from "./images/Furniture2.png"
import home_furniture from "./images/home_furniture.png"
import laptop from "./images/laptop and mobile.jpg"
import fashion from "./images/fashion2.jpg"
import Shoes from "./images/ShoesItems/Shoes1.png"

import AllProductItems1 from "./images/AllProductItems/AllProductItems1.png"
import AllProductItems2 from "./images/AllProductItems/AllProductItems2.png"
import AllProductItems3 from "./images/AllProductItems/AllProductItems3.png"
import AllProductItems4 from "./images/AllProductItems/AllProductItems4.png"
import AllProductItems5 from "./images/AllProductItems/AllProductItems5.png"
import AllProductItems6 from "./images/AllProductItems/AllProductItems6.png"
import AllProductItems7 from "./images/AllProductItems/AllProductItems7.png"
import AllProductItems8 from "./images/AllProductItems/AllProductItems8.png"
import AllProductItems9 from "./images/AllProductItems/AllProductItems9.png"
import AllProductItems10 from "./images/AllProductItems/AllProductItems10.png"
import AllProductItems11 from "./images/AllProductItems/AllProductItems11.png"
import AllProductItems12 from "./images/AllProductItems/AllProductItems12.png"


import s1 from "./images/SummerImages/s1.png"
import s2 from "./images/SummerImages/s2.png"
import s3 from "./images/SummerImages/s3.png"
import s4 from "./images/SummerImages/s4.png"
import s5 from "./images/SummerImages/s5.png"
import s6 from "./images/SummerImages/s6.png"
import s7 from "./images/SummerImages/s7.png"
import s8 from "./images/SummerImages/blackShirt.png"
import s9 from "./images/SummerImages/whiteShirt.png"
import s10 from "./images/SummerImages/s8.png"
import s11 from "./images/SummerImages/s9.png"
import s12 from "./images/SummerImages/s10.png"

import FurnitureItem1 from "./images/FurnitureItems/FurnitureItem1.png"
import FurnitureItem4 from "./images/FurnitureItems/FurnitureItem4.png"
import FurnitureItem5 from "./images/FurnitureItems/FurnitureItem5.png"
import FurnitureItem6 from "./images/FurnitureItems/FurnitureItem6.png"
import FurnitureItem7 from "./images/FurnitureItems/FurnitureItem7.png"
import FurnitureItem9 from "./images/FurnitureItems/FurnitureItem9.png"
import FurnitureItem10 from "./images/FurnitureItems/FurnitureItem10.png"
import FurnitureItem11 from "./images/FurnitureItems/FurnitureItem11.png"
import FurnitureItem13 from "./images/FurnitureItems/FurnitureItem13.png"
import FurnitureItem14 from "./images/FurnitureItems/FurnitureItem14.png"
import FurnitureItem15 from "./images/FurnitureItems/FurnitureItem15.png"


import Shoes1 from "./images/ShoesItems/Shoes.png";
import Shoes2 from "./images/ShoesItems/Shoes2.png";
import Shoes3 from "./images/ShoesItems/Shoes3.png";
import Shoes4 from "./images/ShoesItems/Shoes4.png";
import Shoes5 from "./images/ShoesItems/Shoes5.png";
import Shoes6 from "./images/ShoesItems/Shoes6.png";
import Shoes7 from "./images/ShoesItems/Shoes7.png";
import Shoes8 from "./images/ShoesItems/Shoes8.png";
import Shoes9 from "./images/ShoesItems/Shoes9.png";
import Shoes10 from "./images/ShoesItems/Shoes10.png";
import Shoes11 from "./images/ShoesItems/Shoes_2.png";

import Elec2 from "./images/ElectronicItems/Elec2.png";
import Elec4 from "./images/ElectronicItems/Elec4.png";
import Elec5 from "./images/ElectronicItems/Elec5.png";
import Elec6 from "./images/ElectronicItems/Elec6.png";
import Elec8 from "./images/ElectronicItems/Elec8.png";
import Elec9 from "./images/ElectronicItems/Elec9.png";
import Elec10 from "./images/ElectronicItems/Elec10.png";
import Elec11 from "./images/ElectronicItems/Elec11.png";
import Elec12 from "./images/ElectronicItems/Elec12.png";
import Elec13 from "./images/ElectronicItems/Elec13.png";
import Elec14 from "./images/ElectronicItems/Elec14.png";
import Elec15 from "./images/ElectronicItems/Elec15.png";


export const sliderItems = [
    {
        id:1,
        img: girl ,
        title:"SUMMER SALE",
        desc:"DON'T COMPROMISE ON STYLE GET FLAT 70% OFF FOR NEW ARRIVALS.",
        bg:"f5fafd",
        link:"SummerSale"

    },{
      id:2,
      img: Shoes,
      title:"HUGE DISCOUNTS ON NIKE SHOES!",
      desc:"STEP UP YOUR SHOE GAME WITH UNBEATABLE DEALS!",
      bg:"ffe4c5",
      link:"Shoes"
    },{
        id:3,
        img: furniture ,
        title:"FURNITURE BESTSELLERS",
        desc:"THE MOST POPULAR AND STYLISH FURNITURE YOU NEED!",
        bg:"fdfae5",
        link:"Furniture"
    },
    {
        id:4,
        img: electronic ,
        title:"BIG DISCOUNT ON ELECTRONIC ITEMS!",
        desc:"UP TO 40% CASHBACK ON APPLE PRODUCTS",
        bg:"fbf0f4",
        link:"Electronic"
    },  {
      id:5,
      img: clear,
      title:"CLEARANCE SALE",
      desc:"LAST CHANCE TO GRAB GREAT DEALS ON REMAINING INVENTORY!",
      bg:"fcf1ed",
      link:"ProductList"

  },
];

export const categories = [
    {
        id: 1,
        img: fashion,
        title: "Fashion",
        link:"SummerSale",
      },
      {
        id: 3,
        img: home_furniture,
        title: "Home and Furniture",
        link:"Furniture"
      },
      {
        id: 2,
        img: laptop,
        title: "Mobiles & Tablets",
        link:"Electronic"
      },
];

export const AllProductItems = [
    {
        id: 1,
        img: AllProductItems1,
      },
      {
        id: 2,
        img: AllProductItems2,
      },
      {
        id: 3,
        img: AllProductItems3,
      },
      {
        id: 4,
        img: AllProductItems4,
      },
      {
        id: 5,
        img: AllProductItems5,
      },
      {
        id: 6,
        img: AllProductItems6,
      },
      {
        id: 7,
        img: AllProductItems7,
      },
      {
        id: 8,
        img: AllProductItems8,
      }, {
        id: 9,
        img: AllProductItems9,
      },{
        id: 10,
        img: AllProductItems10,
      },{
        id: 11,
        img: AllProductItems11,
      },{
        id: 12,
        img: AllProductItems12,
      },
];

export const SummerItems = [
  {
      id: 1,
      img: s1,
    },
    {
      id: 2,
      img: s2,
    },
    {
      id: 3,
      img: s3,
    },
    {
      id: 4,
      img: s4,
    },
    {
      id: 5,
      img: s5,
    },
    {
      id: 6,
      img: s6,
    },
    {
      id: 7,
      img: s7,
    },
    {
      id: 8,
      img: s8,
    },
    {
      id: 9,
      img: s9,
    },{
      id: 10,
      img: s10,
    },{
      id: 11,
      img: s11,
    },{
      id: 12,
      img: s12,
    },
];


export const FurnitureItems = [
  {
      id: 1,
      img: FurnitureItem1,
    },
    {
      id: 2,
      img:FurnitureItem10,
    },
    {
      id: 3,
      img: FurnitureItem13,
    },
    {
      id: 4,
      img: FurnitureItem4,
    },
    {
      id: 5,
      img: FurnitureItem5,
    },
    {
      id: 6,
      img: FurnitureItem6,
    },
    {
      id: 7,
      img: FurnitureItem11,
    },
    {
      id: 9,
      img: FurnitureItem9,
    },{
      id: 10,
      img: FurnitureItem15,
    },{
      id: 14,
      img: FurnitureItem14,
    },{
      id: 15,
      img: FurnitureItem7,
    },
];

export const ShoesItems = [
  {
      id: 1,
      img: Shoes1,
    },
    {
      id: 2,
      img:Shoes2,
    },
    {
      id: 3,
      img: Shoes3,
    },
    {
      id: 4,
      img: Shoes4,
    },
    {
      id: 5,
      img: Shoes5,
    },
    {
      id: 6,
      img: Shoes6,
    },
    {
      id: 7,
      img: Shoes7,
    },
    {
      id: 8,
      img: Shoes8,
    },{
      id: 9,
      img: Shoes9,
    },{
      id: 10,
      img: Shoes10,
    },{
      id: 11,
      img: Shoes11,
    },{
      id: 11,
      img: Shoes,
    }
];

export const ElectronicsItems = [
  {
      id: 1,
      img: Elec2,
    },
    {
      id: 2,
      img:Elec14,
    },
    {
      id: 4,
      img: Elec4,
    },
    {
      id: 5,
      img: Elec5,
    },
    {
      id: 6,
      img: Elec6,
    },
    {
      id: 8,
      img: Elec8,
    },{
      id: 9,
      img: Elec9,
    },{
      id: 10,
      img: Elec10,
    },{
      id: 11,
      img: Elec11,
    },{
      id: 12,
      img: Elec12,
    },{
      id: 13,
      img: Elec13,
    },{
      id: 15,
      img: Elec15,
    }
];


// export const FashionItems = [
//   // it is of Fashion category & it will contain all items including AllProductItems, shoes, summerItems 
//   {
//       id: 1,
//       img: s1,
//     },
//     {
//       id: 2,
//       img: s2,
//     },
//     {
//       id: 3,
//       img: s3,
//     },
//     {
//       id: 4,
//       img: s4,
//     },
//     {
//       id: 5,
//       img: s5,
//     },
//     {
//       id: 6,
//       img: s6,
//     },
//     {
//       id: 7,
//       img: s7,
//     },
//     {
//       id: 8,
//       img: s8,
//     },
//     {
//       id: 9,
//       img: s9,
//     },{
//       id: 10,
//       img: s10,
//     },{
//       id: 11,
//       img: s11,
//     },{
//       id: 12,
//       img: s12,
//     },
// ];